import { Box, Typography } from '@mui/material';
import PropertiesTooltip from '~/components/Properties/PropertiesTooltip';
import StructureSetProperties from '~/components/Properties/StructureSetProperties';
import SelectableListItem from '~/components/SelectableListItem/SelectableListItem';
import SensitiveInfoTypography from '~/components/SensitiveInfoTypography';
import { AvailableStructureSet } from '~/hooks/structure-set/useAvailableStructureSets';
import { cutUID } from '~/utils/string';

type StructureSetItemProps = {
    structureSet: AvailableStructureSet;
    isActive?: boolean;
    disabled?: boolean;
    onClick: () => void;
    onDelete?: () => void;
};

export default function StructureSetItem({
    structureSet,
    isActive = false,
    disabled,
    onClick,
    onDelete,
}: StructureSetItemProps) {
    const { label, sopInstanceUID, structureSetObject } = structureSet;

    return (
        <SelectableListItem
            isSelected={isActive}
            onClick={onClick}
            disabled={disabled ?? isActive}
            data-testid={`structureset-menu-item-${label}`}
        >
            <PropertiesTooltip
                title={
                    <StructureSetProperties
                        structureSet={structureSet}
                        onDelete={onDelete}
                    />
                }
            >
                <Box width="100%" overflow="hidden" display="grid">
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        gap={1}
                    >
                        <Typography
                            color={
                                isActive || isActive === undefined
                                    ? 'text.primary'
                                    : 'text.secondary'
                            }
                            fontSize={12}
                            flexWrap="nowrap"
                            sx={{
                                whiteSpace: 'nowrap',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                cursor: 'pointer',
                            }}
                        >
                            {label}
                        </Typography>
                        {structureSetObject && (
                            <Typography
                                fontSize={10}
                                color="text.secondary"
                                flexShrink={0}
                            >
                                {structureSetObject.numberOfStructures} ROIs
                            </Typography>
                        )}
                    </Box>
                    <Box
                        display="flex"
                        justifyContent="space-between"
                        alignItems="center"
                        gap={1}
                        width="100%"
                        overflow="hidden"
                    >
                        <Typography
                            fontSize={10}
                            color="text.secondary"
                            noWrap
                            sx={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                            }}
                        >
                            {cutUID(sopInstanceUID, 4, 4)}
                        </Typography>
                        {structureSet.imageLabel && (
                            <SensitiveInfoTypography>
                                <Typography
                                    component="span"
                                    fontSize={10}
                                    color="text.secondary"
                                    flexShrink={0}
                                >
                                    {structureSet.imageLabel}
                                </Typography>
                            </SensitiveInfoTypography>
                        )}
                    </Box>
                </Box>
            </PropertiesTooltip>
        </SelectableListItem>
    );
}
